import axios from 'axios'

export default {
    /**
     * 查询用户
     */
    async searchAll(data, callback) {
        var res = await axios({
            method: 'post',
            url: 'User_infAction!searchAll',
            data: data,
        });

        res = JSON.parse(res.data.result);
        // 执行回调
        callback(res);
    },

    /**
     * 添加用户
     */
    async add(data, callback) {
        var res = await axios({
            method: 'post',
            url: 'User_infAction!searchAll',
            data: data,
        });

        // 执行回调
        callback(res);
    },

    /**
     * 编辑用户
     */
    async update(data, callback) {
        var res = await axios({
            method: 'post',
            url: 'User_infAction!update',
            data: data,
        });

        // 执行回调
        callback(res);
    },

    /**
     * 删除用户
     */
    async del(data, callback) {
        var res = await axios({
            method: 'post',
            url: 'User_infAction!del',
            data: data,
        });

        // 执行回调
        callback(res);
    },
}